"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_NET_TYPES = exports.TESTNET = exports.MAINNET = void 0;
exports.MAINNET = 0x00;
exports.TESTNET = 0x10;
exports.SUPPORTED_NET_TYPES = [
    exports.MAINNET,
    exports.TESTNET,
];
//# sourceMappingURL=NetTypes.js.map